<p-inputMask styleClass="form-control form-control-sm" mask="(999)999-9999" [(ngModel)]="value" [disabled]="isDisabled" autoClear="true">
</p-inputMask>